//Search and filter
(function($) { "use strict";

    //manual ajax load-more
    $('.sf_results').on('click', 'a.load-more', function(e){

        // alert('clicked');

        //block the click action
        e.preventDefault();
        //remove the load-more button
        $(this).remove();
        //ajax get events
        $.ajax(
            $(this).attr('href'),
            {
                success: function(data) {
                    //find all events in response and append them to the results
                    $('.sf_results > *', data).appendTo($('.sf_results'));

                    //copy over the new load-more link, if it exists
                    // $('.sf_results_pagination', data).appendTo($('.sf_results'));
                },
            }
        )
    });

})(jQuery);









// Listen for AJAX complete event


// jQuery(document).ajaxSend(function(event, xhr, settings) {
//     // Run your custom JavaScript code here for every AJAX request
//     console.log('An AJAX request is being sent:', settings);
//   });



//   jQuery(document).ajaxComplete(function(event, xhr, settings) {
//     // Run your custom JavaScript code here when an AJAX request is complete
//     console.log('22 An AJAX request is complete:', settings);
//   });






    // $('tribe-events-c-top-bar__datepicker-button').trigger( "click" );


    // setTimeout(function() {
    //     $('tribe-events-c-top-bar__datepicker-button').trigger( "click" );
    //     console.log('This message is delayed by 5 seconds.');
    //   }, 5000);
    


    // // Save reference to original XHR object
    // var originalXhr = window.XMLHttpRequest;

    // // Override the XHR constructor
    // function CustomXhr() {
    // var xhr = new originalXhr();
    
    // xhr.addEventListener('load', function() {
    //     if (xhr.responseURL === 'https://bristol.test:3000/wp-json/tribe/views/v2/html') {
    //     console.log('XHR request to', xhr.responseURL, 'is made');
    //     }
    // });

    // return xhr;
    // }

    // // Override the global XMLHttpRequest object
    // window.XMLHttpRequest = CustomXhr;

    // // Make an XHR request
    // var xhr = new XMLHttpRequest();
    // xhr.open('GET', 'https://bristol.test:3000/wp-json/tribe/views/v2/html', true);
    // xhr.send();


